/**
 * Datos completos de productos Retail
 * Incluye descripciones, ingredientes, formatos e información detallada
 */

export const retailProductsData = {
  // CATEGORÍA 1: KETCHUP EN CRISTAL
  ketchupCristal: [
    {
      id: 'ketchup-cristal',
      name: 'Ketchup Intercasa',
      shortName: 'Ketchup',
      category: 'Ketchup en Cristal',
      categorySlug: 'ketchup-cristal',
      shortDescription: 'Ketchup clásico elaborado en Canarias con tomates seleccionados.',
      description: 'Nuestro ketchup clásico, elaborado en Canarias con tomates seleccionados, tiene un sabor equilibrado y familiar que acompaña perfectamente cualquier plato del día a día',
      ingredients: 'Concentrado de tomate, azúcar, vinagre, sal, almidón modificado de maíz, estabilizantes (goma guar, goma garrofín, pectinas), conservador (benzoato sódico) y aromas.',
      formats: ['320g', '530g'],
      formatDisplay: 'CRISTAL 320g | 530g',
      idealFor: 'Bocadillos, papas fritas, carnes, pasta y cualquier receta rápida en casa.',
      productType: 'Retail',
      image: '/images/productos/retail/Ketchup_cristal_320gr.webp',
      formatImages: {
        '320g': '/images/productos/retail/Ketchup_cristal_320gr.webp',
        '530g': '/images/productos/retail/Ketchup_cristal_530gr.webp'
      }
    },
    {
      id: 'ketchup-zero-cristal',
      name: 'Ketchup Zero',
      shortName: 'Ketchup Zero',
      category: 'Ketchup en Cristal',
      categorySlug: 'ketchup-cristal',
      shortDescription: 'Sin azúcares añadidos, ligero y con el sabor Intercasa.',
      description: 'La opción sin azúcares añadidos para quienes buscan un ketchup más ligero sin renunciar al sabor tan característico de Intercasa',
      ingredients: 'Concentrado de tomate, puré de manzana, edulcorante (maltitol), vinagre de alcohol, sal, almidón modificado de maíz, estabilizante (goma guar), conservador (benzoato sódico), edulcorante (sucralosa) y aromas.',
      formats: ['320g'],
      formatDisplay: 'CRISTAL 320g',
      idealFor: 'Comidas ligeras, recetas saludables, acompañar sin remordimientos.',
      productType: 'Retail',
      image: '/images/productos/retail/Ketchup_cristal_zero_320gr.webp'
    },
    {
      id: 'ketchup-picante-cristal',
      name: 'Ketchup Picante',
      shortName: 'Ketchup Picante',
      category: 'Ketchup en Cristal',
      categorySlug: 'ketchup-cristal',
      shortDescription: 'El ketchup de siempre con un toque picante que le da carácter.',
      description: 'Nuestro ketchup de siempre, pero con un toque picante que le da carácter. Una receta pensada para quienes disfrutan de un poco más de intensidad en cada bocado',
      ingredients: 'Concentrado de tomate, azúcar, vinagre, sal, almidón modificado de maíz, estabilizantes (goma guar, goma garrofín, pectinas), conservador (benzoato sódico) y aromas.',
      formats: ['320g'],
      formatDisplay: 'CRISTAL 320g',
      idealFor: 'Carnes, papas, bocadillos y platos que piden un punto atrevido.',
      productType: 'Retail',
      image: '/images/productos/retail/Ketchup_picante_cristal_320gr.webp'
    }
  ],

  // CATEGORÍA 2: LÍNEA PE
  lineaPE: [
    {
      id: 'ketchup-pe',
      name: 'Ketchup Intercasa PE',
      shortName: 'Ketchup',
      category: 'Línea PE',
      categorySlug: 'linea-pe',
      shortDescription: 'Ketchup práctico con el sabor equilibrado de siempre.',
      description: 'Un ketchup práctico y cómodo para el día a día, con el sabor equilibrado de los tomates seleccionados y el formato ideal para tener siempre a mano en casa.',
      ingredients: 'Tomates (192g de tomate por 100g de kétchup), azúcar, vinagre, sal, almidón modificado de maíz, estabilizantes (goma guar, goma garrofín, pectinas), conservador (benzoato sódico) y aromas.',
      formats: ['300g PE', '450g PE'],
      formatDisplay: 'PE 300g | 450g',
      idealFor: 'Bocadillos, papas, carnes a la plancha y comidas rápidas en familia.',
      productType: 'Retail',
      image: '/images/productos/retail/Ketchup_PE_300gr.webp',
      formatImages: {
        '300g PE': '/images/productos/retail/Ketchup_PE_300gr.webp',
        '450g PE': '/images/productos/retail/Ketchup_PE_450gr.webp'
      }
    },
    {
      id: 'mostaza-dulce-original-pe',
      name: 'Mostaza Dulce Original',
      shortName: 'Mostaza Dulce Original',
      category: 'Línea PE',
      categorySlug: 'linea-pe',
      shortDescription: 'Receta clásica de mostaza dulce, suave y equilibrada.',
      description: 'Nuestra receta clásica de mostaza dulce, con un sabor suave y equilibrado que acompaña perfectamente carnes, salchichas o bocadillos',
      ingredients: 'Agua, azúcar, vinagre de alcohol, harina de mostaza, aceite de girasol, sal, especias, estabilizantes (goma guar, goma xantana, goma garrofín, pectinas), aromas (apio) y conservadores (benzoato de sodio y sorbato de potasio).',
      formats: ['300g PE', '450g PE'],
      formatDisplay: 'PE 300g | 450g',
      idealFor: 'Perritos calientes, bocadillos, carnes y recetas que necesitan un toque dulce.',
      productType: 'Retail',
      image: '/images/productos/retail/Mostaza_dulce_original_PE_300g.webp',
      formatImages: {
        '300g PE': '/images/productos/retail/Mostaza_dulce_original_PE_300g.webp',
        '450g PE': '/images/productos/retail/Mostaza_dulce_original_PE_300g.webp'
      }
    },
    {
      id: 'mostaza-dulce-pe',
      name: 'Mostaza Dulce',
      shortName: 'Mostaza Dulce',
      category: 'Línea PE',
      categorySlug: 'linea-pe',
      shortDescription: 'Mostaza cremosa con toque amable y ligeramente especiado.',
      description: 'Una versión más actual de nuestra mostaza dulce, con una textura cremosa y un sabor pensado para quienes disfrutan de un toque amable y ligeramente especiado.',
      ingredients: 'Agua, azúcar, vinagre de alochol, harina de mostaza, estabilizantes (goma guar goma xantana y almidón modificado de maíz), sal, aceite de girasol, conservador (metabisulfito potásico y sorbato potásico) colorante (caramelo) y especias. Contiene dióxido de azufre y sulfitos en concentraciones superiores a 10mg/kg.',
      formats: ['300g PE', '450g PE'],
      formatDisplay: 'PE 300g | 450g',
      idealFor: 'Carnes blancas, papas, sándwiches y elaboraciones sencillas.',
      productType: 'Retail',
      image: '/images/productos/retail/Mostaza_dulce_PE_300g.webp',
      formatImages: {
        '300g PE': '/images/productos/retail/Mostaza_dulce_PE_300g.webp',
        '450g PE': '/images/productos/retail/Mostaza_dulce_PE_450g.webp'
      }
    },
    {
      id: 'salsa-barbacoa-pe',
      name: 'Salsa Barbacoa',
      shortName: 'Barbacoa',
      category: 'Línea PE',
      categorySlug: 'linea-pe',
      shortDescription: 'Sabor intenso y ahumado, ideal para carnes y parrillas.',
      description: 'Una salsa barbacoa de sabor intenso y ligeramente ahumado, ideal para darle carácter a carnes, hamburguesas y recetas a la parrilla',
      ingredients: 'Concentrado de tomate, azúcar, jarabe de melaza, vinagre de alcohol, sal, almidón modificado de maíz, aroma de humo, estabilizante (goma guar), conservador (benzoato sódico), especias y aromas.',
      formats: ['300g PE', '450g PE'],
      formatDisplay: 'PE 300g | 450g',
      idealFor: 'Carnes a la parrilla, hamburguesas, papas y marinados.',
      productType: 'Retail',
      image: '/images/productos/retail/Barbacoa_PE_300g.webp',
      formatImages: {
        '300g PE': '/images/productos/retail/Barbacoa_PE_300g.webp',
        '450g PE': '/images/productos/retail/Barbacoa_PE_450g.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Barbacoa.webp'
    }
  ],

  // CATEGORÍA 3: ALIOLI Y MAYONESA
  alioliMayonesa: [
    {
      id: 'mayonesa-pe',
      name: 'Mayonesa Intercasa',
      shortName: 'Mayonesa',
      category: 'Alioli y Mayonesa',
      categorySlug: 'alioli-mayonesa',
      shortDescription: 'Mayonesa suave y cremosa, elaborada en Canarias.',
      description: 'Una mayonesa suave y cremosa, elaborada en Canarias con una textura perfecta para acompañar platos del día a día y realzar su sabor sin resultar pesada',
      ingredients: 'Aceite de girasol (64%), agua, huevo y yema de huevo (6,5%), vinagre de vino blanco, azúcar, sal, almidón modificado de maíz, estabilizante (goma garrofín), zumo de limón, conservador (sorbato potásico), mostaza, acidulante (ácido cítrico), antioxidante (EDTA), colorante (betacaroteno) y aromas.',
      formats: ['430ml PE'],
      formatDisplay: 'PE 430ml',
      idealFor: 'Papas, ensaladas, bocadillos, carnes frías y recetas rápidas para compartir.',
      productType: 'Retail',
      image: '/images/productos/retail/Mayonesa_PET_300ml.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Mayonesa.webp'
    },
    {
      id: 'alioli-receta-canaria-pe',
      name: 'Alioli Receta Canaria',
      shortName: 'Alioli Receta Canaria',
      category: 'Alioli y Mayonesa',
      categorySlug: 'alioli-mayonesa',
      shortDescription: 'Receta canaria tradicional con sabor intenso y textura suave.',
      description: 'Nuestro alioli tradicional, elaborado con una receta canaria que combina un sabor intenso y una textura suave, ideal para acompañar platos caseros con un toque auténtico.',
      ingredients: 'Aceite de girasol (64%), agua, huevo y yema de huevo(6,5%), ajo natural (4,8%), vinagre de vino blanco, azúcar, perejil, sal, almidón modificado de maíz, estabilizante (goma garrofín), zumo de limón, conservador (sorbato potásico), mostaza, acidulante (ácido cítrico), antioxidante (EDTA), colorante (betacaroteno) y aromas.',
      formats: ['300ml PE', '430ml PE'],
      formatDisplay: 'PE 300ml | 430ml',
      idealFor: 'Papas arrugadas, carnes, pescados, bocadillos y snacks.',
      productType: 'Retail',
      image: '/images/productos/retail/Aliol_PET_300ml.webp',
      formatImages: {
        '300ml PE': '/images/productos/retail/Aliol_PET_300ml.webp',
        '430ml PE': '/images/productos/retail/Alioli_PET_430ml.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Alioli.webp'
    }
  ],

  // CATEGORÍA 4: TOMATES EN CONSERVA
  tomates: [
    {
      id: 'tomate-entero-pelado',
      name: 'Tomate Entero Pelado',
      shortName: 'Tomate Entero Pelado',
      category: 'Tomates en Conserva',
      categorySlug: 'tomates-conserva',
      shortDescription: 'Tomates enteros con jugo natural para salsas caseras.',
      description: 'Tomates enteros pelados y envasados con su jugo natural, ideales para preparar salsas caseras y recetas tradicionales con un sabor auténtico.',
      ingredients: 'Tomate, jugo de tomate, sal, acidulante: E330 y endurecedor: E509.',
      formats: ['380g', '765g'],
      formatDisplay: '380g | 765g',
      idealFor: 'Salsas, guisos, recetas caseras y platos que requieren tomate natural.',
      productType: 'Retail',
      image: '/images/productos/retail/Tomate_pelado_lata_380g.webp',
      formatImages: {
        '380g': '/images/productos/retail/Tomate_pelado_lata_380g.webp',
        '765g': '/images/productos/retail/Tomate_pelado_lata_765g.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-picante-pe.webp'
    },
    {
      id: 'tomate-frito',
      name: 'Tomate Frito',
      shortName: 'Tomate Frito',
      category: 'Tomates en Conserva',
      categorySlug: 'tomates-conserva',
      shortDescription: 'Salsa de tomate lista para usar con sabor casero.',
      description: 'Salsa de tomate lista para usar, con una textura suave y un sabor casero que facilita la preparación de platos rápidos y sabrosos',
      ingredients: 'Concentrado de tomate, aceite de girasol, azúcar, sal, almidón de maíz modificado, espesantes (goma guar, goma garrofín, pectinas), aromas (contiene soja), conservante (benzoato de sodio), especias.',
      formats: ['350g'],
      formatDisplay: '350g',
      idealFor: 'Pasta, arroces, carnes, pizzas y recetas rápidas del día a día.',
      productType: 'Retail',
      image: '/images/productos/retail/Tomate_frito_350g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-picante-pe.webp'
    },
    {
      id: 'tomate-triturado',
      name: 'Tomate Triturado',
      shortName: 'Tomate Triturado',
      category: 'Tomates en Conserva',
      categorySlug: 'tomates-conserva',
      shortDescription: 'Textura homogénea, perfecto como base para salsas.',
      description: 'Tomate triturado de textura homogénea, perfecto como base para salsas, guisos y elaboraciones que necesitan un sabor intenso y natural.',
      ingredients: 'Tomate triturado (99%), sal y acidulante ácido cítrico (Sólo se añade acidulante cuando se requiere corregir la acidez del tomate).',
      formats: ['400g', '800g'],
      formatDisplay: '400g | 800g',
      idealFor: 'Salsas caseras, recetas de cuchara, guisos y bases de cocina.',
      productType: 'Retail',
      image: '/images/productos/retail/Tomate_triturado_lata_400g.webp',
      formatImages: {
        '400g': '/images/productos/retail/Tomate_triturado_lata_400g.webp',
        '800g': '/images/productos/retail/Tomate_triturado_lata_800g.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-picante-pe.webp'
    },
    {
      id: 'doble-concentrado-tomate',
      name: 'Doble Concentrado de Tomate',
      shortName: 'Doble Concentrado de Tomate',
      category: 'Tomates en Conserva',
      categorySlug: 'tomates-conserva',
      shortDescription: 'Concentrado intenso para potenciar salsas y recetas.',
      description: 'Un concentrado de tomate con sabor intenso, pensado para potenciar el color y la profundidad de salsas y recetas tradicionales.',
      ingredients: 'Tomates.',
      formats: ['140g', '400g'],
      formatDisplay: '140g | 400g',
      idealFor: 'Salsas, estofados, marinados y recetas que requieren un toque extra de intensidad.',
      productType: 'Retail',
      image: '/images/productos/retail/Concetrado_tomate_lata_140g.webp',
      formatImages: {
        '140g': '/images/productos/retail/Concetrado_tomate_lata_140g.webp',
        '400g': '/images/productos/HORECA/Concentrado_tomate_lata_400g.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-picante-pe.webp'
    }
  ]
};

/**
 * Obtiene todos los productos retail en un array plano
 * @returns {Array} Array con todos los productos
 */
export const getAllRetailProducts = () => {
  return [
    ...retailProductsData.ketchupCristal,
    ...retailProductsData.lineaPE,
    ...retailProductsData.alioliMayonesa,
    ...retailProductsData.tomates
  ];
};

/**
 * Busca un producto por su ID
 * @param {string} productId - ID del producto
 * @returns {Object|null} Producto encontrado o null
 */
export const getProductById = (productId) => {
  const allProducts = getAllRetailProducts();
  return allProducts.find(product => product.id === productId) || null;
};

/**
 * Obtiene productos por categoría
 * @param {string} categorySlug - Slug de la categoría
 * @returns {Array} Array de productos de la categoría
 */
export const getProductsByCategory = (categorySlug) => {
  const categoryMap = {
    'ketchup-cristal': retailProductsData.ketchupCristal,
    'linea-pe': retailProductsData.lineaPE,
    'alioli-mayonesa': retailProductsData.alioliMayonesa,
    'tomates-conserva': retailProductsData.tomates
  };
  return categoryMap[categorySlug] || [];
};
